import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PosTerminalSupportService } from '../pos-terminal-support.service';

// "Support connected" over every window (Ionic modals too) while an admin is connected to this
// terminal; the arrow moves it to the next corner.
@Component({
  selector: 'app-support-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngIf="support.state$ | async as state">
      <div
        *ngIf="state.status === 'connected'"
        class="support-badge"
        [ngClass]="'support-badge--' + (support.corner$ | async)"
        role="status"
      >
        <span class="support-badge__dot"></span>
        <span class="support-badge__text">
          <b>Підтримку підключено</b>
          <small *ngIf="state.operator">{{ state.operator }}</small>
        </span>
        <button type="button" class="support-badge__move" title="Перемістити" (click)="support.moveBadge()">⤢</button>
      </div>
    </ng-container>
  `,
  styles: [
    `
      .support-badge {
        position: fixed;
        z-index: 2147483000;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 6px 6px 12px;
        border-radius: 20px;
        background: #1b5e20;
        color: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        font-size: 13px;
        line-height: 1.2;
        pointer-events: auto;
      }
      .support-badge--top-right {
        top: calc(8px + env(safe-area-inset-top, 0px));
        right: calc(8px + env(safe-area-inset-right, 0px));
      }
      .support-badge--top-left {
        top: calc(8px + env(safe-area-inset-top, 0px));
        left: calc(8px + env(safe-area-inset-left, 0px));
      }
      .support-badge--bottom-left {
        bottom: calc(8px + env(safe-area-inset-bottom, 0px));
        left: calc(8px + env(safe-area-inset-left, 0px));
      }
      .support-badge--bottom-right {
        bottom: calc(8px + env(safe-area-inset-bottom, 0px));
        right: calc(8px + env(safe-area-inset-right, 0px));
      }
      .support-badge__dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #69f0ae;
        box-shadow: 0 0 0 0 rgba(105, 240, 174, 0.7);
        animation: support-pulse 1.6s infinite;
      }
      .support-badge__text {
        display: flex;
        flex-direction: column;
      }
      .support-badge__text small {
        opacity: 0.8;
      }
      .support-badge__move {
        width: 28px;
        height: 28px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.18);
        color: #fff;
        font-size: 15px;
        cursor: pointer;
      }
      @keyframes support-pulse {
        70% {
          box-shadow: 0 0 0 7px rgba(105, 240, 174, 0);
        }
        100% {
          box-shadow: 0 0 0 0 rgba(105, 240, 174, 0);
        }
      }
    `,
  ],
})
export class SupportBadgeComponent {
  constructor(public support: PosTerminalSupportService) {}
}
